import Link from "./link.vue";

export default {
    components: { Link },
    props: {
        footerLinks: {
            type: Array,
            require: true
        }
    },
    template:
    `
    <div class="footer">
        <div class="footer__link-container">
            <Link
                v-for="(footerLink, index) in footerLinks" 
                :key="index" 
                :footer-link="footerLink"
            />
        </div>

        <div class="footer__btn-container">
            <slot />
        </div>
    </div>
    `
}
